import { Action } from "redux";

import { GET_OFFER_RESPONSE_BY_ID, GET_OFFER_RESPONSES } from "./types";

interface OfferResponseAction extends Action {
  payload: any;
}

const initialState = {
  currentOfferResponse: null,
  offerResponses: [],
};

export default (state = initialState, action: OfferResponseAction) => {
  switch (action.type) {
    case GET_OFFER_RESPONSE_BY_ID:
      return {
        ...state,
        currentOfferResponse: action.payload,
      };
    case GET_OFFER_RESPONSES:
      return {
        ...state,
        offerResponses: action.payload,
      };
    default:
      return state;
  }
};
